import React, { ReactElement } from "react";
import "./StreamOffline.scss";
import Logo from "../icons/logo.svg";
import { StreamState } from "../../types";

interface StreamOfflineProps {
  state: StreamState;
}
const StreamOffline = (
  props: StreamOfflineProps
): ReactElement<StreamOfflineProps> => {
  const { state } = props;

  return (
    <div className="stream-offline-container">
      <div className="stream-offline">
        <img className="logo" alt="logo" src={Logo} />
        <div className="title">
          {state === StreamState.AuthError
            ? "You are not authorized to view this stream."
            : "Broadcast currently not live."}
        </div>
        <div className="subtitle">
          {state === StreamState.AuthError ? "" : "Please check back soon."}
        </div>
      </div>
    </div>
  );
};

export default StreamOffline;
